<!--  -->
<template>
  <div class="indentInfo">
    <!-- 本期不做修改地址只做添加地址  当前判断逻辑是 订单需要添加地址时订单没有绑定地址图标-->
    <div class="indentInfo-address" v-if="showAddress(orderDetail)">
      <div class="title">
        <div class="title-icon">
          <img src="@/assets/img/personalImg/local.png" />
        </div>
        <div class="title-hint" v-if="!orderDetail.bindAddress">
          该课程含有配套资料，请添加收货地址，否则无法给您发货
        </div>
        <div class="title-user" v-if="orderDetail.orderUserAddressVO != null">
          <span class="span1">
            <p class="name">
              {{ orderDetail.orderUserAddressVO.consignee }}
            </p>
            <p class="phone">
              {{ orderDetail.orderUserAddressVO.phone }}
            </p>
          </span>
          <span
            ><p class="local">{{ orderDetail.orderUserAddressVO.addressDetail }}</p></span
          >
        </div>
        <img
          v-if="orderDetail.needAddress && !orderDetail.bindAddress"
          src="@/assets/img/personalImg/compile.png"
          class="title-img"
          @click="addAdresss(orderDetail)"
        />
      </div>
    </div>
    <div class="indentInfo-class">
      <div class="package" v-if="orderDetail.packageProductList">
        <div v-for="(child, index) in orderDetail.packageProductList" :key="index">
          <div v-if="index !== 0" class="box-line"></div>
          <div class="package-name">
            <p>{{ child.packageName }}</p>
            <div class="title-desc" v-if="!memberPackage">
              <img
                src="https://iqh-zt-pord-cdn.iqihang.com/identInfo/%E7%9F%A9%E5%BD%A2%402x.png"
              />
              <span>包含以下课程：</span>
            </div>
          </div>
          <productList
            v-if="!memberPackage"
            :productVOList="child.orderProductVOList"
            hideDiscountLabel
          />
        </div>
      </div>
      <productList :productVOList="orderDetail.productVOList" />
    </div>
  </div>
</template>

<script>
import productList from './productList.vue';

export default {
  props: {
    orderDetail: {
      type: Object,
    },
    memberPackage: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {};
  },

  components: {
    productList,
  },

  computed: {},

  mounted() {},

  methods: {
    // 是否展示地址模块
    showAddress(data) {
      const { needAddress, status } = data;
      let result = true;
      if (status === 4 || status === 5) {
        result = false;
      } else if (!needAddress) {
        result = false;
      }
      return result;
    },
    addAdresss(orderDetail) {
      const { orderNo, bindAddress, orderUserAddressVO } = orderDetail;
      // bindAddress=0新增地址 1 修改地址
      if (bindAddress) {
        const { orderAddressId } = orderUserAddressVO;
        this.$router.push({
          path: '/personalCenter/address',
          query: { bindAddress, orderNo, orderAddressId },
        });
        sessionStorage.setItem('bindAddress', bindAddress);
      } else {
        this.$router.push({
          path: '/personalCenter/address',
          query: { bindAddress, orderNo, onlyAddress: true },
        });
        sessionStorage.setItem('bindAddress', bindAddress);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.indentInfo {
  margin-bottom: 22px;
  &-address {
    display: flex;
    align-content: center;
    justify-content: center;
    width: 100%;
    height: 145px;
    margin-bottom: 22px;
    padding: 36px;
    overflow: hidden;
    background: $bgWhite;
    border-radius: 14px;
    .title {
      display: flex;
      align-items: center;
      justify-content: space-between;
      width: 100%;
      &-icon {
        img {
          width: 54px;
          height: 53px;
        }
      }
      &-hint {
        width: 428px;
        height: 72px;
        color: $theme_color;
        font-size: 25px;
        line-height: 36px;
      }
      &-user {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        width: 465px;
        height: 80px;
        font-size: 25px;
        line-height: 36px;
        .span1 {
          display: flex;
          .name {
            margin-right: 25px;
            color: $fontColorBlack;
            font-weight: 500;
          }
        }
        .local {
          color: $fontColorBlackLight;
          @extend .ellipsis;
        }
      }
      &-img {
        width: 43px;
        height: 43px;
      }
    }
  }
  &-class {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    width: 100%;
    // height: 239px;
    padding: 29px 36px 9px;
    background: $bgWhite;
    border-radius: 14px;
    .box-line {
      width: 678px;
      height: 2px;
      margin: 36px 0;
      margin-left: -36px;
      background: #f0f0f0;
    }
    .package-name {
      padding: 0 0 22px 0;
      > p {
        color: #333;
        font-weight: 500;
        font-size: 29px;
        line-height: 40px;
      }
      .title-desc {
        width: 100%;
        height: 36px;
        margin-top: 36px;
        line-height: 0px;
        > img {
          width: 14px;
          height: 18px;
        }
        > span {
          margin-left: 8px;
          color: #ff6c02;
          font-weight: 500;
          font-size: 25px;
          line-height: 36px;
        }
      }
    }
  }
}
</style>
